import { render, staticRenderFns } from "./MembersChooseDialog.vue?vue&type=template&id=be3645f4&scoped=true"
import script from "./MembersChooseDialog.vue?vue&type=script&lang=ts"
export * from "./MembersChooseDialog.vue?vue&type=script&lang=ts"
import style0 from "./MembersChooseDialog.vue?vue&type=style&index=0&id=be3645f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3645f4",
  null
  
)

export default component.exports